/* eslint-disable sort-keys-fix/sort-keys-fix */
import { COMMUNITY_PAGES_PATH_PREFIX, type CommunityData } from "./types"

const aamagazine: CommunityData = {
  code: "aaMagazine",
  inviteCode: "aaMagazine",
  name: "AaMagazine",
  thumbnail: "",
  favicon: "",
  url: `${COMMUNITY_PAGES_PATH_PREFIX}/aaMagazine`,
  socials: {},
  styles: {
    global: {
      counterColor: "#A30000",
      logo: {
        src: "/assets/customizations/aaMagazine/logo.png",
        styles: "w-[64px]",
      },
      alternativeLogo: {
        src: "/assets/customizations/aaMagazine/logo.png",
        styles: "w-[122px]",
      },
      modalWindow: {
        container: "",
        title: "",
        subtitle: "",
      },
      contentBoxShadow: "border-[1px] border-[#000000]",
      bgColor: "#E9E7E3",
      asideBg: "#E9E7E3",
      asideStyles: "border-r-[#000000] border-r",
      contentBg: "#E9E7E3",
      bgDesktop: "/assets/customizations/aaMagazine/bg.png",
      bgMobile: "/assets/customizations/aaMagazine/bg.png",
      mainFont: "font-['HelveticaNeue']",
      primaryButton:
        "flex mt-2 !text-[#A30000] font-bold rounded-full justify-center items-center !text-[16px] pt-1 !h-[44px] bg-[#E9E7E3] uppercase border-[#A30000] border-[1px] !px-[32px] sm:!min-w-[156px] min-w-[160px] text-nowrap cursor-pointer",
    },
    navigation: {
      sideBarSeparator: "",
      iconsColor: "#A30000",
      separator: "border-t-[#000000] border-t",
      item: "text-[16px] uppercase text-[#A30000] h-[40px] font-bold flex sm:justify-start justify-center items-center sm:!pt-2 !pt-6",
      itemSelected: "custom-prefix",
    },
    communityLanding: {
      titles: "text-[24px] text-[#A30000] font-bold leading-[30px] uppercase",
      announcements: {
        lg: {
          title:
            "!text-[13px] -mb-1 mt-[-4px] px-[6px] w-fit h-[19px] flex items-center text-medium",
          subtitle:
            "!text-[12px] px-[6px] !pt-[6px] !bg-[#A30000] !text-[#FFF] w-fit h-[19px] flex items-center text-medium",
        },
        sm: {
          title: "!text-[13px] mt-[-4px] px-[6px] w-fit h-[19px] flex items-center text-medium",
          subtitle:
            "!text-[12px] px-[6px] !pt-[6px] !bg-[#A30000] !text-[#FFF] w-fit h-[19px] flex items-center text-medium",
        },
      },
      event: {
        title: "text-[#A30000] text-[19px] text-medium one-line-truncate",
        subtitle: "text-[#A30000] text-[12px] leading-[16px] text-medium",
      },
      shop: {
        title: "text-[24px] text-[#A30000] font-bold leading-[30px] uppercase",
        text: "text-[#A30000] text-[12px] leading-[16px] text-medium",
        customShopImage: "",
      },
      emptyOrLoadingState: "text-[#A30000] text-[14px]",
    },
    announcements: {
      container: "mb-16 sm:p-11 p-7 sm:space-y-[38px] space-y-[33px]",
      header: "text-[24px] font-bold uppercase text-[#A30000] leading-[40px]",
      created: "text-[#A30000] text-[14px] font-medium leading-[17px]",
      title: "text-[16px] text-[#A30000] leading-[35px] uppercase font-bold",
      description: "text-[#A30000] text-[14px] font-medium leading-[17px]",
      emptyOrLoadingState: "text-[#A30000] text-[14px]",
    },
    announcement: {
      container: "sm:p-10 p-7 pb-8 space-y-[23px]",
      created: "text-[#A30000] text-[14px] font-medium leading-[17px]",
      title: "text-[16px] text-[#A30000] leading-[35px] uppercase font-bold",
      description: "text-[#A30000] text-[14px] font-medium leading-[17px]",
      likeCount: "text-[#A30000]",
      likeIconColor: "#A30000",
      commentCount: "text-[#A30000]",
      commentIconColor: "#A30000",
      emptyOrLoadingState: "text-[#A30000] text-[14px]",
    },
    events: {
      sectionHeader: "text-[#A30000] text-[16px] leading-[20px] uppercase font-bold",
      container: "mb-16 sm:p-11 p-7 sm:pb-8 sm:space-y-[57px] space-y-[25px]",
      header: "text-[24px] font-bold uppercase text-[#A30000] leading-[40px]",
      title: "text-[16px] text-[#A30000] leading-[35px] uppercase font-bold",
      emptyOrLoadingState: "text-[#A30000] text-[14px]",
      duration: "text-[#A30000] font-medium leading-[17px] !text-[14px]",
      address: "text-[#A30000] font-medium leading-[17px] !text-[14px]",
      separator: "mb-8 mt-2 border-b border-b-[1px] border-[#89A6CC]",
    },
    event: {
      blockContainer: "flex flex-col gap-3",
      container: "flex flex-col sm:p-11 p-6",
      emptyOrLoadingState: "text-[#A30000] text-[14px]",
      header:
        "text-[24px] font-bold uppercase text-[#A30000] leading-[40px] !mt-0 sm:mb-0 mb-[24px]",
      sectionSubtitle: "text-[#A30000] font-medium leading-[17px] !text-[14px]",
      sectionTitle: "text-[#A30000] text-[16px] leading-[20px] uppercase font-bold",
      text: "text-[#A30000] text-[14px] font-medium leading-[17px]",
      separator: "sm:my-8 my-6 border-b border-b-[1px] border-[#89A6CC]",
      map: {
        pin: "",
        border: "mb-2 border-[1px] border-[#89A6CC] overflow-hidden",
        pinColor: "#A30000",
        strokeColor: "#A30000",
      },
    },
    eventTickets: {
      container: "flex flex-col sm:p-11 p-6",
      event: {
        title: "font-bold uppercase text-[#A30000] !mt-0 text-[24px] leading-[40px]",
        subtitle: "text-[#A30000] font-medium leading-[17px] !text-[14px]",
      },
      ticket: {
        title: "text-[16px] text-[#A30000] leading-[20px] uppercase font-bold",
        description: "text-[14px] leading-[17px] capitalize font-medium",
        text: "capitalize text-[14px] leading-[17px] font-medium",
        price: "text-[24px] font-bold text-[#A30000]",
        counterContainer: "text-[20px] !text-[#A30000] rounded-full !border-[#A30000]",
        quantity:
          "text-nowrap text-[#A30000] pt-1 rounded-full text-[16px] !border-[#A30000] font-bold",
      },
      separator: "sm:my-8 my-6 border-b-[#89A6CC] border-b-[1px]",
    },
    shop: {},
    linktree: {
      container:
        "font-['HelveticaNeue'] flex flex-col items-center h-full w-full bg-cover min-h-screen relative bg-[#000000] p-[64px]",
      bgDesktop: "/assets/customizations/aaMagazine/bg.png",
      bgMobile: "/assets/customizations/aaMagazine/bg.png",
      communityInfo: {
        logo: "h-[128px] w-[128px] rounded-full border border-[#89A6CC] border-[2px]",
        name: "text-[24px] text-[#A30000] uppercase font-bold mt-2",
        location: "text-[#A30000] text-[14px] mb-2 font-medium",
        description: "text-[#A30000] text-[14px] font-medium leading-[17px] text-center mb-4",
        socialMediaIconColor: "#A30000",
        button:
          "flex mt-2 !text-[#A30000] font-bold rounded-full justify-center items-center !text-[16px] pt-1 !h-[44px] bg-[#E9E7E3] uppercase border-[#A30000] border-[1px] !px-[24px] text-nowrap cursor-pointer",
      },
      upcomingEvents: {
        loadingState:
          "mb-[42px] font-bold text-[#A30000] border-[2px] border-[#89A6CC] !h-[56px] sm:w-[500px] w-[95vw] p-4 flex bg-[#E9E7E3] items-center text-[16px] uppercase",
        emptyState: {
          container:
            "border-[#89A6CC] border-[1px] sm:w-[500px] w-[95vw] bg-[#E9E7E3] flex justify-between flex flex-col justify-center items-center p-[34px] mb-[32px]",
          title: "text-[16px] !text-[#A30000] uppercase font-bold",
          text: "text-[10px] !text-[#A30000] uppercase font-medium",
          button:
            "flex mt-4 !text-[#A30000] font-bold rounded-full justify-center items-center !text-[16px] pt-1 !h-[44px] bg-[#E9E7E3] uppercase border-[#A30000] border-[1px] !px-[24px] text-nowrap cursor-pointer",
        },
        header: "text-[24px] !text-[#A30000] uppercase font-bold mb-[10px] text-center w-screen",
        container: "gap-4 flex flex-col items-center",
        collapsedEvent: {
          container:
            "h-[64px] border-[#89A6CC] border-[1px] bg-[#E9E7E3] cursor-pointer sm:w-[500px] w-[95vw] flex justify-between pr-2",
          name: "text-[16px] font-bold text-[#A30000] uppercase leading-[20px] pt-[2px] sm:w-[390px] w-[65vw]",
          duration: "text-[10px] mt-[-2px] uppercase text-[#A30000] font-medium",
          plusIconColor: "#A30000",
          media: "overflow-hidden m-2",
        },
        event: {
          container:
            "overflow-hidden border-[#89A6CC] border-[1px] bg-[#E9E7E3] sm:w-[500px] w-[95vw]",
          name: "text-[16px] font-bold text-[#A30000] uppercase leading-[20px] mb-1 sm:w-[390px] w-[65vw]",
          duration: "text-[10px] uppercase text-[#A30000] font-medium",
          location: "text-[10px] mb-4 text-[#A30000] font-medium",
          startDate:
            "font-medium !w-[64px] text-[#F6F4E7] text-[24px] h-[64px] bg-[#A30000] flex flex-col justify-center items-center gap-1",
          button:
            "flex !text-[#A30000] font-bold rounded-full justify-center items-center !text-[16px] pt-1 !h-[44px] bg-[#E9E7E3] uppercase border-[#A30000] border-[1px] !px-[24px] text-nowrap cursor-pointer w-fit",
          product: {
            container:
              "h-[73px] border-t border-t-[#89A6CC] px-4 items-center flex justify-between",
            name: "uppercase text-[16px] font-bold text-[#A30000] leading-[20px] mb-1 one-line-truncate sm:w-[390px] w-[65vw]",
            price: "text-[14px] font-medium text-[#A30000]",
            status: "text-[14px] font-bold text-[#A30000]",
            link: "text-[14px] font-medium text-[#A30000]",
            button:
              "flex !text-[#A30000] font-bold rounded-full justify-center items-center !text-[16px] pt-1 !h-[44px] bg-[#E9E7E3] uppercase border-[#A30000] border-[1px] !px-[24px] text-nowrap cursor-pointer w-fit",
          },
        },
        seeAllEvents:
          "text-[13px] text-[#A30000] uppercase underline font-bold text-center mt-4 cursor-pointer mb-[32px]",
      },
      news: {
        container: "flex flex-col gap-4",
        loadingState:
          "mb-[42px] font-bold text-[#A30000] border-[2px] border-[#89A6CC] !h-[56px] sm:w-[500px] w-[95vw] p-4 flex bg-[#E9E7E3] items-center text-[16px] uppercase",
        header: "text-[24px] !text-[#A30000] uppercase font-bold mb-[10px] text-center w-screen",
        oneNews: {
          container:
            "pr-2 overflow-hidden bg-[#E9E7E3] border-[1px] border-[#89A6CC] h-[64px] cursor-pointer sm:w-[500px] w-[95vw] flex justify-between",
          name: "font-bold text-[#A30000] mt-[2px] text-[16px] leading-[20px] mb-1 one-line-truncate sm:w-[390px] w-[65vw]",
          triangleIconColor: "#A30000",
          created: "text-[10px] leading-[12px] mt-[-4px] text-[#A30000] font-medium",
          media: "overflow-hidden m-2",
        },
        seeAllNews:
          "text-[13px] text-[#A30000] uppercase underline font-bold text-center mt-4 cursor-pointer mb-[32px]",
      },
      otherLinks: {
        container: "flex flex-col gap-[10px] mb-[40px]",
        loadingState:
          "mb-[42px] font-bold text-[#A30000] border-[2px] border-[#89A6CC] !h-[56px] sm:w-[500px] w-[95vw] p-4 flex bg-[#E9E7E3] items-center text-[16px] uppercase",
        header: "text-[28px] mb-[10px] text-center w-screen",
        link: {
          container:
            "h-[56px] border-[1px] border-[#89A6CC] cursor-pointer p-2 sm:w-[500px] w-[95vw] flex justify-between bg-[#E9E7E3]",
          name: "text-[16px] text-[#A30000] font-bold leading-[20px] mb-[6px] mt-[8px] one-line-truncate sm:w-[390px] w-[65vw]",
          triangleIconColor: "#A30000",
          circleIcon: "ml-2 w-[24px] h-[24px] rounded-full object-cover",
        },
      },
      footer: {
        WERZlogoColor: "#000",
        text: "uppercase font-mono text-[11px] font-bold text-[#000]",
      },
    },
  },
}

export default aamagazine
